import React, { Component } from "react";
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import withAuth from "../../../components/withAuth";

// STATE AND STORE
// LIBS
import API from "../../../api";
import Model from "../../../models/filials";
import validateForm from "../../../lib/helpers/validateForm";

// UI
import {
  Alerts,
  Box,
  Button,
  Header,
  HeaderPage,
  Input,
  Table,
  ButtonGroup
} from "../../../ui";

class FilialPricesEditPage extends Component {
  state = {
    titleHeader: "Изменение процентов",
    filial: {},
    formPrices: [],
    buttons: {
      saveDisabled: false
    }
  };

  async componentDidMount() {
    const { id } = this.props.match.params;

    const filial = await API.filials.getOne(id);

    let formPrices = [];
    let prices =
      filial &&
      filial.prices_id &&
      filial.prices_id.prices &&
      filial.prices_id.prices.length
        ? filial.prices_id.prices
        : null;

    if (prices) {
      // Заполняем форму
      prices.forEach(price => {
        const countryId = price.prices_countrys_id._id;

        // Для выбранной страны
        formPrices[countryId] = {
          price_id: price._id,
          country_id: countryId,
          country_title: price.prices_countrys_id.title,
          listProbs: {}
        };

        price.probs.forEach(prob => {
          const probId = prob.prices_probs_id._id;

          // Для выбранной пробы
          formPrices[countryId]["listProbs"][probId] = {
            price_prob_id: prob._id,
            prob_id: probId,
            prob_title: prob.prices_probs_id.title,
            listPrices: {
              price_new: {
                value: String(prob.price_new) || "0",
                isEdited: false,
                isNumber: true,
                isError: false,
                errors: [],
                validate: Model.prices.price_new
              },
              price_normal: {
                value: String(prob.price_normal) || "0",
                isEdited: false,
                isNumber: true,
                isError: false,
                errors: [],
                validate: Model.prices.price_normal
              },
              price_crack: {
                value: String(prob.price_crack) || "0",
                isEdited: false,
                isNumber: true,
                isError: false,
                errors: [],
                validate: Model.prices.price_crack
              }
            }
          };
        });
      });
    }

    this.setState({ filial, formPrices });
  }

  handleInput = e => {
    let value = e.target.value;
    let [countryId, probId, name] = String(e.target.name).split(":");
    const { formPrices } = this.state;
    let formElement =
      formPrices[countryId]["listProbs"][probId]["listPrices"][name];

    formElement = {
      ...formElement,
      value: formElement.isNumber ? String(value) || "" : value,
      isEdited: true,
      isError: false,
      errors: []
    };

    formPrices[countryId]["listProbs"][probId]["listPrices"][
      name
    ] = formElement;

    this.setState({ formPrices });
  };

  handleFormSubmit = async e => {
    e.preventDefault();

    this.setState(prevState => {
      return {
        buttons: {
          ...prevState.buttons,
          saveDisabled: true
        }
      };
    });

    const results = [];
    let isValid = true;
    const formPricesValidate = this.state.formPrices;

    // Берём по странам
    for (let countryId in formPricesValidate) {
      // Берём по пробам
      for (let probId in formPricesValidate[countryId]["listProbs"]) {
        let form =
          formPricesValidate[countryId]["listProbs"][probId]["listPrices"];

        results[probId] = validateForm(form);
        form = results[probId].form;

        if (!results[probId].valid) {
          isValid = false;
        }

        formPricesValidate[countryId]["listProbs"][probId]["listPrices"] = form;
      }
    }

    this.setState({ formPrices: formPricesValidate });

    // Если форма валидна
    if (isValid) {
      const { formPrices } = this.state;
      const filialId = this.props.match.params.id;
      const pricesId = this.state.filial.prices_id._id;

      let isEdited = false;

      const pricesSendToServer = [];

      // Берём по странам
      for (let countryId in formPrices) {
        // Нужно ли вставлять данные в форму для отправки?
        let isNeedInsertCountry = false;
        // Подготавливаем данные для вставки
        let priceObject = {
          price_id: "",
          prices_countrys_id: "",
          probs: []
        };

        // Берём по пробам
        for (let probId in formPrices[countryId]["listProbs"]) {
          // Подготавливаем данные для вставки
          let priceProbsObject = {
            prob_id: "",
            prices_probs_id: "",
            price: {}
          };
          let priceProbsPriceObject = {};

          let itemProb = formPrices[countryId]["listProbs"][probId];
          let form = itemProb["listPrices"];

          for (let formFieldKey in form) {
            if (form[formFieldKey].isEdited) {
              priceProbsPriceObject[formFieldKey] =
                parseInt(form[formFieldKey].value, 10) || 0;
            }
          }

          // Если есть данные для отправки
          if (Object.keys(priceProbsPriceObject).length) {
            // Указываем данные для текущей пробы
            priceProbsObject = {
              prob_id: itemProb["price_prob_id"],
              prices_probs_id: probId,
              price: priceProbsPriceObject
            };

            // Добавляем в массив проб для текущей страны производителя
            priceObject.price_id = formPrices[countryId]["price_id"];
            priceObject.prices_countrys_id = countryId;
            priceObject.probs.push(priceProbsObject);

            // Указываем что есть данные для вставки
            isNeedInsertCountry = true;
          }
        }

        // Если есть данные для вставки
        if (isNeedInsertCountry) {
          pricesSendToServer.push(priceObject);

          // Указываем что есть данные для отправки на сервер
          isEdited = true;
        }
      }

      // Если изменения
      if (isEdited) {
        // Изменение текущего
        const resultUpdated = await API.filials.editOnePrices(
          filialId,
          pricesId,
          {
            prices: pricesSendToServer
          }
        );

        if (resultUpdated) {
          Alerts.success("Расценки изменёны");
          // Включаем кнопку, данные сохранились
          this.setState(prevState => {
            return {
              buttons: {
                ...prevState.buttons,
                saveDisabled: false
              }
            };
          });

          this.props.history.goBack();
        } else {
          Alerts.error("Расценки не изменёны");

          // Включаем кнопку, данные не сохранились
          this.setState(prevState => {
            return {
              buttons: {
                ...prevState.buttons,
                saveDisabled: false
              }
            };
          });
        }
      } else {
        Alerts.alert("В расценках нет изменений");

        // Включаем кнопку, данные не сохранились
        this.setState(prevState => {
          return {
            buttons: {
              ...prevState.buttons,
              saveDisabled: false
            }
          };
        });

        this.props.history.goBack();
      }
    } else {
      Alerts.warn("Валидация...");

      this.setState(prevState => {
        return {
          buttons: {
            ...prevState.buttons,
            saveDisabled: false
          }
        };
      });
    }
  };

  getTableColumns = () => {
    return [
      {
        title: "Страна",
        suffix: "Производителя"
      },
      {
        title: "Проба",
        suffix: "золота"
      },
      {
        title: "Новое",
        suffix: "состояние"
      },
      {
        title: "Нормальное",
        suffix: "состояние"
      },
      {
        title: "Лом",
        suffix: "состояние"
      }
    ];
  };

  getTableBody = () => {
    const { formPrices } = this.state;
    let list = [];

    if (formPrices && Object.keys(formPrices).length) {
      // Берём по странам
      for (let countryId in formPrices) {
        let itemRow = 0;

        // Берём по пробам
        for (let probId in formPrices[countryId]["listProbs"]) {
          const form = formPrices[countryId]["listProbs"][probId]["listPrices"];

          // Формируем форму расценкок
          list.push(
            <tr key={`filial-prices-${countryId}-${probId}`}>
              {!itemRow ? (
                <td
                  rowSpan={
                    Object.keys(formPrices[countryId]["listProbs"]).length
                  }
                >
                  {formPrices[countryId]["country_title"]}
                </td>
              ) : null}

              <td>
                {formPrices[countryId]["listProbs"][probId]["prob_title"]}
              </td>

              <td>
                <Input
                  name={`${countryId}:${probId}:price_new`}
                  type="integer"
                  value={form.price_new.value}
                  errors={form.price_new.errors}
                  handleChange={this.handleInput}
                  inTable={true}
                />
              </td>
              <td>
                <Input
                  name={`${countryId}:${probId}:price_normal`}
                  type="integer"
                  value={form.price_normal.value}
                  errors={form.price_normal.errors}
                  handleChange={this.handleInput}
                  inTable={true}
                />
              </td>
              <td>
                <Input
                  name={`${countryId}:${probId}:price_crack`}
                  type="integer"
                  value={form.price_crack.value}
                  errors={form.price_crack.errors}
                  handleChange={this.handleInput}
                  inTable={true}
                />
              </td>
            </tr>
          );

          // Увеличиваем, чтобы понять, что первый столбец со страной уже вставлен
          itemRow = itemRow + 1;
        }
      }
    }

    return list;
  };

  render() {
    return (
      <div className="short">
        <Helmet>
          <title>{this.state.titleHeader}</title>
        </Helmet>

        <HeaderPage
          title={this.state.titleHeader}
          back={this.props.history.goBack}
        >
          <ButtonGroup>
            <Button
              type="submit"
              theme="success"
              onClick={this.handleFormSubmit}
              disabled={this.state.buttons.saveDisabled}
            >
              Сохранить изменения
            </Button>
            <Button
              type="button"
              onClick={() => this.props.history.goBack()}
              theme="default"
            >
              Отмена
            </Button>
          </ButtonGroup>
        </HeaderPage>

        <form className="form" onSubmit={this.handleFormSubmit}>
          <Box>
            <Header size={4}>Расценки</Header>

            <Table
              columns={this.getTableColumns()}
              tbody={this.getTableBody()}
            />
          </Box>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => ({});

export default withAuth(connect(mapStateToProps)(FilialPricesEditPage));
